import { getEnv } from '@src/apis/shared';

import * as mock from './themeVersions.mock';
import * as real from './themeVersions.real';
import type { GetThemeVersions, TriggerThemeDeploy, GetPipelineStatus } from './types';

export * from './types';

/**
 * Choose the mock or the real theme-versions client from an env flag, evaluated per call so a change
 * in env.js/.env takes effect on reload without a rebuild — and so the mock stays usable for local
 * dev even once the real backend is reachable (toggle in env, not by editing source).
 *
 * Default is the REAL client; set `STOREFRONT_API_USE_MOCK='true'` to use the mock. Deployed envs
 * set this explicitly in their `dotenv.dist` (false); local dev sets it in env.js.
 */
const shouldUseMock = (): boolean => getEnv('STOREFRONT_API_USE_MOCK') === 'true';

export const getThemeVersions: GetThemeVersions = partnerCode =>
  (shouldUseMock() ? mock : real).getThemeVersions(partnerCode);

export const triggerThemeDeploy: TriggerThemeDeploy = (partnerCode, selector) =>
  (shouldUseMock() ? mock : real).triggerThemeDeploy(partnerCode, selector);

export const getPipelineStatus: GetPipelineStatus = (partnerCode, uuid) =>
  (shouldUseMock() ? mock : real).getPipelineStatus(partnerCode, uuid);
